export default __webpack_public_path__ + "static/news-default-75144562dcbae3b78e2125102099db3e.jpg";